import { render, staticRenderFns } from "./TreatmentsRejection.vue?vue&type=template&id=6a2804b2"
import script from "./TreatmentsRejection.vue?vue&type=script&lang=js"
export * from "./TreatmentsRejection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports